"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./Buttons.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Buttons
    
	Multiple button types returned
	depending on what the user needs

    Verified by: Yorben Verhoestest
    Date: 06/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Our main component
var Buttons = function Buttons(btn) {
  switch (btn.type) {
    // Main button
    case 'main':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "buttonWrapper ".concat(btn.size ? btn.size : ''),
        "aria-label": btn.label
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "button main",
        onClick: btn.onClick,
        style: {
          'color': btn.txtColor ? "var(--".concat(btn.txtColor, ")") : 'var(--main)'
        }
      }, btn.url ? /*#__PURE__*/_react["default"].createElement("a", {
        href: btn.url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, btn.icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: btn.icon
      }), btn.text ? btn.text : 'button') : btn.text ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, btn.icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: btn.icon
      }), btn.text) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, btn.icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: btn.icon
      }), "button"), btn.submit && /*#__PURE__*/_react["default"].createElement("input", {
        type: "submit",
        value: "",
        "aria-label": "submit"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn_overlay",
        style: {
          'background': btn.bgColor[0] ? btn.bgColor.length > 1 ? "linear-gradient(45deg, var(--".concat(btn.bgColor[0], ") 0%, var(--").concat(btn.bgColor[1], ") 50%, var(--").concat(btn.bgColor[0], ") 100%)") : "var(--".concat(btn.bgColor[0], ")") : 'var(--main)'
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "buttonShadow",
        style: {
          'boxShadow': btn.bgColor[0] ? "0 0px 10px 0 var(--".concat(btn.bgColor[0], ")") : '0 2px 5px 0 rgba(0,0,0,0.2)'
        }
      }));
    // Sub button

    case 'sub':
      var button_sub_border = btn.size === 'S' ? 1 : 2,
          button_sub_style = {
        boxShadow: btn.borderColor ? "0 0 0 ".concat(button_sub_border, "px var(--").concat(btn.borderColor, ")") : "0 0 0 ".concat(button_sub_border, "px var(--main)"),
        color: btn.txtColor ? "var(--".concat(btn.txtColor, ")") : 'var(--main)'
      };
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: ['buttonWrapper', btn.size ? btn.size : ''].join(' '),
        "aria-label": btn.label
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: ['button sub', btn.negative ? 'negative' : undefined].join(' '),
        style: button_sub_style,
        onClick: btn.onClick
      }, btn.url ? /*#__PURE__*/_react["default"].createElement("a", {
        href: btn.url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, btn.icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: btn.icon
      }), btn.text ? btn.text : 'button') : btn.text ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, btn.icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: btn.icon
      }), btn.text) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, btn.icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: btn.icon
      }), "button"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn_overlay",
        style: {
          'backgroundColor': btn.borderColor ? "var(--".concat(btn.borderColor, ")") : 'var(--main)'
        }
      })));
    // Regular button

    case 'regular':
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "buttonRegular",
        onClick: btn.onClick ? btn.onClick : undefined,
        "aria-label": btn.label
      }, btn.icon && /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        name: btn.icon
      }), btn.text);
    // On / Off toggle button

    case 'toggle':
      return /*#__PURE__*/_react["default"].createElement("label", {
        className: "buttonToggle ".concat(btn.label ? 'label' : ''),
        title: btn.label ? btn.label : '',
        "aria-label": btn.label
      }, btn.label && /*#__PURE__*/_react["default"].createElement("span", {
        className: "buttonToggle_label_text",
        style: {
          order: btn.label_position === 'right' ? 1 : 0
        }
      }, btn.label), /*#__PURE__*/_react["default"].createElement("input", {
        "aria-label": btn.label,
        type: "checkbox",
        checked: btn.checked,
        onChange: function onChange(e) {
          return btn.onChange ? btn.onChange(e.target.checked) : undefined;
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "slider round"
      }));
    // Icon button

    case 'icon':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "buttonIconWrapper ".concat(btn.size ? btn.size : ''),
        "aria-label": btn.label
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "button buttonIcon",
        style: {
          'color': btn.iconColor ? "var(--".concat(btn.iconColor, ")") : 'white'
        },
        onClick: btn.onClick
      }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
        animated: btn.animated,
        name: btn.icon
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn_overlay",
        style: {
          'background': btn.bgColor[0] ? btn.bgColor.length > 1 ? "linear-gradient(45deg, var(--".concat(btn.bgColor[0], ") 0%, var(--").concat(btn.bgColor[1], ") 50%, var(--").concat(btn.bgColor[0], ") 100%)") : "var(--".concat(btn.bgColor[0], ")") : 'var(--main)'
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "buttonShadow",
        style: {
          'boxShadow': btn.bgColor[0] ? "0 0px 10px 0 var(--".concat(btn.bgColor[0], ")") : '0 2px 5px 0 rgba(0,0,0,0.2)'
        }
      }));

    default:
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "button",
        onClick: btn.onClick ? btn.onClick : undefined
      }, btn.text);
  }
};

var _default = Buttons;
exports["default"] = _default;